// 自动生成的文件 - 请勿手动修改
import { am } from './am';
import { ar } from './ar';
import { bg } from './bg';
import { bn } from './bn';
import { bs } from './bs';
import { ca } from './ca';
import { cs } from './cs';
import { da } from './da';
import { de } from './de';
import { el } from './el';
import { en_US } from './en-US';
import { es_419 } from './es-419';
import { es_ES } from './es-ES';
import { et } from './et';
import { fi } from './fi';
import { fr_CA } from './fr-CA';
import { fr_FR } from './fr-FR';
import { gu } from './gu';
import { hi } from './hi';
import { hr } from './hr';
import { hu } from './hu';
import { hy } from './hy';
import { id } from './id';
import { is } from './is';
import { it } from './it';
import { ja } from './ja';
import { ka } from './ka';
import { kk } from './kk';
import { kn } from './kn';
import { ko } from './ko';
import { lt } from './lt';
import { lv } from './lv';
import { mk } from './mk';
import { ml } from './ml';
import { mn } from './mn';
import { mr } from './mr';
import { ms } from './ms';
import { my } from './my';
import { pt_BR } from './pt-BR';
import { pt_PT } from './pt-PT';
import { ro } from './ro';
import { ru } from './ru';
import { sk } from './sk';
import { sl } from './sl';
import { so } from './so';
import { sq } from './sq';
import { sr } from './sr';
import { sv } from './sv';
import { sw } from './sw';
import { ta } from './ta';
import { te } from './te';
import { th } from './th';
import { tl } from './tl';
import { tr } from './tr';
import { uk } from './uk';
import { ur } from './ur';
import { vi } from './vi';
import { zh_HK } from './zh-HK';
import { zh_TW } from './zh-TW';
import { zh_CN } from './zh-CN';
import { fa } from './fa';
import { pl } from './pl';
import { nl } from './nl';
import { he } from './he';
import { no } from './no';
import { uz } from './uz';
import { az } from './az';
import { pa } from './pa';
import { ha } from './ha';
import { yo } from './yo';
import { ig } from './ig';
import { si } from './si';
import { ne } from './ne';
import { km } from './km';
import { lo } from './lo';
import { zu } from './zu';
import { mg } from './mg';
import { st } from './st';
import { tn } from './tn';
import { ln } from './ln';
import { rw } from './rw';
import { ti } from './ti';
import { tk } from './tk';
import { tg } from './tg';
import { ku } from './ku';
import { ps } from './ps';
import { jv } from './jv';
import { sd } from './sd';
import { mt } from './mt';

export const allTranslations = {
  'am': am,
  'ar': ar,
  'bg': bg,
  'bn': bn,
  'bs': bs,
  'ca': ca,
  'cs': cs,
  'da': da,
  'de': de,
  'el': el,
  'en-US': en_US,
  'es-419': es_419,
  'es-ES': es_ES,
  'et': et,
  'fi': fi,
  'fr-CA': fr_CA,
  'fr-FR': fr_FR,
  'gu': gu,
  'hi': hi,
  'hr': hr,
  'hu': hu,
  'hy': hy,
  'id': id,
  'is': is,
  'it': it,
  'ja': ja,
  'ka': ka,
  'kk': kk,
  'kn': kn,
  'ko': ko,
  'lt': lt,
  'lv': lv,
  'mk': mk,
  'ml': ml,
  'mn': mn,
  'mr': mr,
  'ms': ms,
  'my': my,
  'pt-BR': pt_BR,
  'pt-PT': pt_PT,
  'ro': ro,
  'ru': ru,
  'sk': sk,
  'sl': sl,
  'so': so,
  'sq': sq,
  'sr': sr,
  'sv': sv,
  'sw': sw,
  'ta': ta,
  'te': te,
  'th': th,
  'tl': tl,
  'tr': tr,
  'uk': uk,
  'ur': ur,
  'vi': vi,
  'zh-HK': zh_HK,
  'zh-TW': zh_TW,
  'zh-CN': zh_CN,
  'fa': fa,
  'pl': pl,
  'nl': nl,
  'he': he,
  'no': no,
  'uz': uz,
  'az': az,
  'pa': pa,
  'ha': ha,
  'yo': yo,
  'ig': ig,
  'si': si,
  'ne': ne,
  'km': km,
  'lo': lo,
  'zu': zu,
  'mg': mg,
  'st': st,
  'tn': tn,
  'ln': ln,
  'rw': rw,
  'ti': ti,
  'tk': tk,
  'tg': tg,
  'ku': ku,
  'ps': ps,
  'jv': jv,
  'sd': sd,
  'mt': mt,
};
